import { Component, EventEmitter } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { first } from 'rxjs/operators';
import { CommercialPermitSearchResult } from '../../../commercialpermitting/models/commercial-permit-search-result.model';
import { CommercialVehiclePermitType, ICommercialVehiclePermitType } from '../../../commercialpermitting/models/enums/commercial-vehicle-permit-type.enum';
import { CommercialPermitService } from '../../../commercialpermitting/services/commercial-permit.service';
import { BaseComponent } from '../../../shared/base-components/base.component';

@Component({
    selector: 'cvp-transaction-type',
    inputs: ['businessTransactionTypeId', 'customer'],
    outputs: ['onBusinessTransactionParamRemoved', 'onBusinessTransactionParamSelected', 'handleDisplayError'],
    templateUrl: './cvp-transaction-type.html',
})
export class CVPTransactionTypeComponent extends BaseComponent {
    public businessTransactionTypeId: number;
    public customer: any;
    public dataLoaded = false;
    public resultsLoaded = false;
    public readOnly = false;
    public permits: CommercialPermitSearchResult[];
    public selectedPermit: CommercialPermitSearchResult;
    public permitTypes: ICommercialVehiclePermitType[];
    public onBusinessTransactionParamRemoved = new EventEmitter<any>();
    public onBusinessTransactionParamSelected = new EventEmitter<any>();
    public handleDisplayError = new EventEmitter<string>();
    public previousPage = -1;
    public dataStore: any = [];
    public totalRecords: number;

    constructor(private commercialPermitService: CommercialPermitService) {
        super();
    }

    public async ngOnInit() {
        this.permitTypes = new CommercialVehiclePermitType().GetAll();
        this.dataLoaded = true;
        this.selectedPermit = null;
        this.dataLoaded = true;
    }

    public async populatePermits(event: LazyLoadEvent) {
        var pageNumber = event.first / 10;

        if (pageNumber > this.previousPage) {
            let result = await this.commercialPermitService.searchCommercialPermitsByCustomerNumberIdPaginated(this.customer.customerNumber, pageNumber).pipe(first()).toPromise();
            this.dataStore.push(...result);
            this.permits = this.dataStore.slice(event.first, (event.first + event.rows));
            if (this.permits.length > 0) {
                this.totalRecords = (pageNumber + 1) * 10 + 1;
            }

            this.previousPage = pageNumber;
        } else {
            this.permits = this.dataStore.slice(event.first, (event.first + event.rows));
        }

        this.resultsLoaded = true;

    }

    public onPermitSelected(permit: CommercialPermitSearchResult) {
        if (this.businessTransactionTypeId == 1156 && permit.commercialVehiclePermitStatusTypeId != 1) {
            this.handleDisplayError.emit('The permit selected has already been consumed or has expired.');
        } else {
            this.selectedPermit = permit;
            const businessTransactionObject = { businessTransactionParamId: this.selectedPermit.commercialVehiclePermitNumberId, businessTransactionItemKeyTypeId: 32 };
            this.onBusinessTransactionParamSelected.emit(businessTransactionObject);
        }
    }

    public onRemovePermit() {
        this.selectedPermit = null;
    }
}
